export const validateTermsForm = (formData) => {
    const errors = [];
  
    if (!formData.cancelationPolicy || formData.cancelationPolicy.trim() === "") {
      errors.push({
        errorType: "cancelationPolicy",
        error: "Cancellation policy is required"
      });
    } else {
      const validPolicies = ["Relaxed", "Moderate", "Strict"];
      if (!validPolicies.includes(formData.cancelationPolicy)) {
        errors.push({
          errorType: "cancelationPolicy",
          error: "Please select a valid cancellation policy"
        });
      }
    }
  
    return {isValid: errors.length === 0, errors};
  };